import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService }    from '@ngx-translate/core';

@Pipe({
  name: 'eventStatus',
})
export class EventStatusPipe implements PipeTransform {

  constructor(
    private translateService : TranslateService
  ) {}

  transform( value : string ) {
    switch (value) {
      case 'C':
        return `<span class="label label-default">${ this.translateService.instant('STATUS_TYPES.CLOSED') }</span>`;
      case 'O':
        return `<span class="label label-success">${ this.translateService.instant('STATUS_TYPES.OPEN') }</span>`;
      default:
        return `<span class="label label-success">${ this.translateService.instant('STATUS_TYPES.OPEN') }</span>`;
    }
  }
}